export function assert(expr, message: string) {
  if (!Boolean(expr)) {
    throw new Error(message || "unknown assertion error");
  }
}
